import { useEffect, useRef } from 'react'
import { useElara } from './useElara'
import type { DiagnosticSection } from '../types'

const DEBOUNCE_MS = 200

/**
 * Reports component state to the ELARA state aggregator.
 * Debounced to avoid excessive updates during rapid changes.
 */
export function useElaraState(section: DiagnosticSection, state: Record<string, any>): void {
    const elara = useElara()
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const stateRef = useRef(state)
    stateRef.current = state

    useEffect(() => {
        if (!elara) return

        if (timerRef.current) {
            clearTimeout(timerRef.current)
        }

        timerRef.current = setTimeout(() => {
            elara.updateUIState(section, stateRef.current)
        }, DEBOUNCE_MS)

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }
        }
    }, [elara, section, state])
}
